import classNames from "classnames";
import { useNavigate } from "react-router-dom";
import { BackIcon } from "components/atoms/Icon";
import { Typography } from "components/atoms";
import "./index.scss";

interface IProps {
  theme: "light" | "dark";
  fallbackPath?: string;
  label?: string;
  className?: string;
  /**
   * Optional override for back navigation.
   * If provided, this handler is called instead of the default history/fallback logic.
   */
  onBack?: () => void;
}

/**
 * Generic back button: uses browser history when possible, otherwise falls back to a provided route.
 * Consumers can override click handling via `onBack`.
 */
export const BackButton = ({
  theme,
  fallbackPath = "/study-planner",
  label = "Back",
  className,
  onBack,
}: IProps) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
      return;
    }

    const canGoBack =
      typeof window !== "undefined" && window.history && window.history.length > 1;

    if (canGoBack) {
      navigate(-1);
    } else {
      navigate(fallbackPath);
    }
  };

  return (
    <div className={classNames("back-button", className)}>
      <div className="back-icon">
        <BackIcon
          color={theme === "light" ? "#273E5A" : "#329EE2"}
          onClickHandle={handleBack}
        />
      </div>
      <div className="back-text">
        <Typography
          label={label}
          variant="h6Medium"
          styles="back-button-text"
          onClick={handleBack}
        />
      </div>
    </div>
  );
};

